/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "^bootstrap|$" }] */
import '@babel/polyfill';
import $ from 'jquery';
import 'bootstrap';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Toggles from './js/toggles';
import SocialLinkBuilder from './js/sociallinks';
import ReturnToTop from './js/returntotop';
import SearchAnimation from './js/searchanimation';
import Tabs from './js/tabs';
import { MainMenu, MobileNav, UnitFlagshipNav } from './js/menu';
import Page from './js/page';
import Accordions from './js/accordion';
import MobileApp from './js/mobileapp';
import './index.scss';
import CACLoginPage from './js/cac-login-page';

gsap.install(window);
gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', () => {
  // social icons
  const socialIcons = (window.skinvars && window.skinvars.SocialLinks)
    ? window.skinvars.SocialLinks
    : {};
  SocialLinkBuilder(socialIcons);

  // dnn & header toggles
  Toggles();

  // bootstrap Tabs
  Tabs();

  // to-top animation
  ReturnToTop();

  // main and mobile menus
  MainMenu();
  MobileNav();
  UnitFlagshipNav();

  // engage accordions
  Accordions();

  // search / social animation
  const searchanimate = new SearchAnimation();
  searchanimate.start();

  // page controllers
  Page();
  MobileApp();

  // CAC Login Page
  CACLoginPage();
}, false);
